export const GOOGLE_MAPS_LIBRARIES = ['places'];
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
